<!-- 
程式：addFireInsurance.vue
功能：火險
作者：i94005ws01 王子齊
完成：2020-10-29
-->
<template>
  <div class="tab-pane pt-3 active show">
    <div class="insurance-editor">
      <div class="col-12">
        <h4><span class="text-thin">分類：</span>火險</h4>
        <form class="form">
          <div class="panel panel-form">
            <div class="form-group row">
              <label class="col-2 text-right">
                <span class="text-red">*</span>被保險人
              </label>
              <div class="col-9 text" v-if="isUpdate">
                <truncate-tool
                  :content="getName(editData.insured)"
                ></truncate-tool>
              </div>
              <div class="col-9" v-else>
                <select
                  class="form-control form-control-inline form-wide"
                  data-vv-name="insured"
                  :class="{ 'is-invalid': errors.has(`insured`) }"
                  v-validate="'required'"
                  v-model="editData.insured"
                  alt="ch"
                >
                  <option value="">請選擇</option>
                  <option
                    v-for="(item, index) in options.families"
                    :key="index"
                    :value="item.csidno"
                  >
                    {{ item.name | truncate }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 text-right">
                <span class="text-red">*</span>產險公司
              </label>
              <div class="col-9 text" v-if="isUpdate">
                {{
                  _.get(
                    options.companies.find(
                      (i) => i.PT_COMPANY_ID === editData.compid
                    ),
                    "COMPNM"
                  )
                }}
              </div>
              <div class="col-9" v-else>
                <select
                  class="form-control form-control-inline form-xLarge"
                  data-vv-name="compid"
                  :class="{ 'is-invalid': errors.has(`compid`) }"
                  v-validate="'required'"
                  v-model="editData.compid"
                >
                  <option value="">請選擇</option>
                  <option
                    v-for="(item, index) in options.companies"
                    :key="index"
                    :value="item.PT_COMPANY_ID"
                  >
                    {{ item.COMPNM }}
                  </option>
                </select>
                <span
                  v-if="options.mrgerCompaniesList.length != 0"
                  class="text"
                  @click="panelOpen('mergeModalOpen')"
                >
                  <a class="link text-underline">公司整併查詢</a>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 text-right">
                <span class="text-red">*</span>契約別
              </label>
              <div class="col-9 text" v-if="isUpdate">
                {{
                  _.get(
                    options.contract_types.find(
                      (i) => i.id === editData.contract_type
                    ),
                    "name"
                  )
                }}
              </div>
              <div class="col-9" v-else>
                <select
                  class="form-control form-control-inline form-wide"
                  data-vv-name="contract_type"
                  :class="{ 'is-invalid': errors.has(`contract_type`) }"
                  v-validate="'required'"
                  v-model="editData.contract_type"
                >
                  <option value="">請選擇</option>
                  <option
                    v-for="(item, index) in options.contract_types"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 text-right">
                <span class="text-red">*</span>保單號碼
              </label>
              <div class="col-9 text" v-if="isUpdate">
                {{ editData.plcno }}
              </div>
              <div class="col-9" v-else>
                <input
                  maxlength="25"
                  class="form-control form-control-inline"
                  data-vv-name="plcno"
                  :class="{ 'is-invalid': errors.has(`plcno`) }"
                  v-validate="'required|checkEngNumDash'"
                  v-model="editData.plcno"
                  @input="checkInput('plcno', 25)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 text-right">
                <span class="text-red">*</span>年期
              </label>
              <div class="col-9">
                <input
                  maxlength="3"
                  class="form-control form-control-inline form-short"
                  data-vv-name="prd"
                  :class="{ 'is-invalid': errors.has(`prd`) }"
                  v-validate="'required|numeric|min_value:1|max:3'"
                  v-model="editData.prd"
                /><span class="text">年</span>
              </div>
            </div>
            <roc-date-picker
              title="投保日期"
              :year.sync="editData.year"
              :month.sync="editData.month"
              :day.sync="editData.day"
              isRequired
              :isCustomYearOption="true"
              :startROCYear="34"
              :endROCYear="thisROCYear"
            >
            </roc-date-picker>
            <div class="form-group row">
              <label class="col-2 text-right">
                <span class="text-red">*</span>保費
              </label>
              <div class="col-9">
                <input
                  maxlength="9"
                  class="form-control form-control-inline"
                  data-vv-name="prem"
                  :class="{ 'is-invalid': errors.has(`prem`) }"
                  v-validate="'required|numeric'"
                  v-model="editData.prem"
                /><span class="text">元</span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 text-right"> 建築完工年份</label>
              <div class="col-9" >
                <select
                  class="form-control form-control-inline form-wide"
                  v-model="editData.target_birth"
                >
                  <option value="">請選擇</option>
                  <option
                    v-for="(item, index) in yearList"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}年
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="action mt-2 text-right">
            <button
              type="button"
              class="btn btn-default"
              @click="cancelAdd(isUpdate ? '修改' : '新增')"
            >
              取消
            </button>
            <button
              v-if="$route.query.canBackToMenu"
              type="button"
              class="btn btn-default"
              @click="toMenu()"
            >
              回上一步
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="isUpdate ? doUpdate() : doCreate()"
            >
              確定
            </button>
          </div>
        </form>
      </div>
    </div>
    <property-company-merge-modal
      @close="panelClose('mergeModalOpen')"
      :open="mergeModalOpen"
      :companiesList="options.mrgerCompaniesList"
    />
  </div>
</template>

<script>
import ThisMixin from "./Car_Fire_New";
import contract_types from "@/desktop/contract/FireInsuranceContractTypes";

export default {
  mixins: [ThisMixin],
  data: () => ({
    options: {
      contract_types,
    },
    editData: {
      insurancetype: 2,
      contract_type: "",
      target_birth: "",
    },
    thisROCYear: new Date().getFullYear() - 1911 + 10,
    thisYear: new Date().getFullYear(),
    startYear: 1900,
  }),
  computed: {
    yearList() {
      return [...Array(this.thisYear + 1 - this.startYear).keys()]
        .map((x) => (this.startYear + x).toString())
        .reverse();
    },
  },
  methods: {
    // 輸入欄位共用檢核
    checkInput(key, limit, unicode = false) {
      let policyNumberPattern = unicode
        ? new RegExp("^[\u4e00-\u9fa5_a-zA-Z0-9\\-]{1," + limit + "}$")
        : new RegExp("^[a-zA-Z0-9\\-]{1," + limit + "}$");
      if (!policyNumberPattern.test(this.editData[key])) {
        this.editData[key] = "";
      } else {
        if (this.stringBytes(this.editData[key], false, limit) > limit) {
          this.editData[key] = this.editData[key].substring(
            0,
            this.stringBytes(this.editData[key], true, limit)
          );
        }
      }
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      var n = c.length,
        s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
  },
};
</script>
